module.exports = __webpack_public_path__ + "img/a67.0c8e808a.png";